<template>
  <div id="navbar">
    <div class id="mobile-nav">
      <nav id="top-nav" class="navbar navbar-dark bg-primary" style="padding: 0.25rem, 1rem;">
        <b-container>
          <button
            class="navbar-toggler text-white text-small-center"
            type="button"
            v-if="getAuthState()"
            data-toggle="collapse"
            data-target="#collapsingNavbar"
            @click="welcomeBtn()"
          >
            Welcome, {{currentUser.user.first_name}}
            <span class="fas fa-caret-down"></span>
          </button>
          <div v-else class="d-flex ml-auto text-small-center">
            <h4
              class="font14 font10 font-weight-bold p-0 my-2 text-white d-flex flex-wrap justify-content-center"
            >
              <span>Uber partner or family member? &nbsp;</span>
              <a
                href="javascript:void(0)"
                @click="LoginUser()"
                class="text-secondary"
                data-attribute="navbar" data-event="link"
                  data-action="click"
                  data-name="onclick"
                  data-type="internal link"
                  data-region="navbar"
                  data-section="authentication navbar"
                  data-text="log in to canvas"
              >Log in to Canvas</a>
            </h4>
          </div>
          <div class="navbar-collapse collapse" id="collapsingNavbar" v-if="getAuthState()">
            <ul class="navbar-nav canvas-nav container">
              <li class="nav-item">
                <a
                  class="nav-link text-white py-0"
                  data-event="link"
                  data-action="click"
                  data-name="onclick"
                  data-type="internal link"
                  data-region="navbar"
                  data-section="authentication navbar"
                  data-text="canvas"
                  href="https://asuce.instructure.com/"
                  data-attribute="navbar"
                >Canvas</a>
              </li>
              <li class="nav-item">
                <a
                  class="nav-link text-white py-0"
                  data-event="link"
                  data-action="click"
                  data-name="onclick"
                  data-type="internal link"
                  data-region="navbar"
                  data-section="authentication navbar"
                  data-text="logout"
                  data-attribute="navbar"
                  href="javascript:void(0)"
                  @click="logUserOut()"
                >Logout</a>
              </li>
            </ul>
          </div>
        </b-container>
      </nav>
      <b-navbar id="secondary-nav" toggleable="lg" variant="faded" type="light">
        <b-container>
          <b-navbar-brand data-attribute="navbar">
            <router-link
                to="/"
                data-attribute="navbar"
                class="img-fluid"
              >
               <img
              src="../assets/images/asu_careercatalyst_logo.png"
              class="d-inline-block align-top asu-careercatalyst-logo"
              alt="ASU CareerCatalyst logo"
            />
              </router-link>
          </b-navbar-brand>
          <b-navbar-toggle target="nav-collapse" id="navbar-toggler" class="d-sm-block d-lg-none">
            <a class="fas fa-bars" v-show="!openNav" data-event="collapse"
                  data-action="open"
                  data-name="onclick"
                  data-type="click"
                  data-region="navbar"
                  data-section="sticky navigation"
                  data-text="lets go" @click="HamburgerButton()"></a>
            <a class="fas fa-times" data-event="collapse"
                  data-action="close"
                  data-name="onclick"
                  data-type="click"
                  data-region="navbar"
                  data-section="sticky navigation"
                  data-text="lets go"
                  v-show="openNav" @click="HamburgerButton()"></a>
          </b-navbar-toggle>
          <b-collapse id="nav-collapse" is-nav class>
            <!-- Right aligned nav items -->
            <b-navbar-nav class="ml-auto d-sm-block d-lg-none">
              <router-link
                tag="li"
                to="/entrepreneurship"
                class="nav-items"
                data-attribute="navbar"
                :class="{'isActive' : $route.name === 'entrepreneurship'}"
              >
                <a class="nav-link" data-title="entrepreneurship" 
            data-event="link"
            data-action="click" 
            data-name="onclick" 
            data-type="internal link" 
            data-region="navbar"
            data-section="sticky navigation"
            data-text="entrepreneurship"
                >Entrepreneurship</a>
              </router-link>
              <router-link
                tag="li"
                to="/english"
                class="nav-items"
                data-attribute="navbar"
                :class="{'isActive' : $route.name === 'english'}"
              >
                <a class="nav-link" data-title="english" data-event="link"
            data-action="click" 
            data-name="onclick" 
            data-type="internal link" 
            data-region="main navbar"
            data-section="sticky navigation"
            data-text="english">English</a>
              </router-link>
              <router-link
                tag="li"
                to="/faq"
                class="nav-items"
                data-attribute="navbar"
                :class="{'isActive' : $route.name === 'faq'}"
              >
                <a class="nav-link" data-title="FAQ"
                 data-event="link"
            data-action="click" 
            data-name="onclick" 
            data-type="internal link" 
            data-region="main navbar"
            data-section="sticky navigation"
            data-text="FAQ"
                >FAQ</a>
              </router-link>
            </b-navbar-nav>
          </b-collapse>
        </b-container>
      </b-navbar>
    </div>
    <section id="shadow-navigation" class="d-none d-lg-block">
      <aside class="container d-flex">
        <ul class="menu-items">
          <router-link
            tag="li"
            to="/"
            class="nav-items"
            data-attribute="navbar"
            :class="{'isActive' : $route.name === 'home'}"
          >
            <a class="nav-link" 
              data-title="homepage" 
              data-event="link"
              data-action="click" 
              data-name="onclick" 
              data-type="internal link" 
              data-region="main navbar"
              data-section="sticky navigation"
              data-text="home"
              aria-label="Home"
              >
                <i class="fas fa-home"></i>
              </a>
          </router-link>
          <router-link
            tag="li"
            to="/entrepreneurship"
            class="nav-items"
            data-attribute="navbar"
            :class="{'isActive' : $route.name === 'entrepreneurship'}"
          >
            <a class="nav-link" data-attribute="navbar" data-title="entrepreneurship"
            data-event="link"
            data-action="click" 
            data-name="onclick" 
            data-type="internal link" 
            data-region="main navbar"
            data-section="sticky navigation"
            data-text="entrepreneurship"
            >Entrepreneurship</a>
          </router-link>
          <router-link
            tag="li"
            to="/english"
            class="nav-items"
            data-attribute="navbar"
            :class="{'isActive' : $route.name === 'english'}"
          >
            <a class="nav-link" data-title="english"
            data-event="link"
            data-action="click" 
            data-name="onclick" 
            data-type="internal link" 
            data-region="main navbar"
            data-section="sticky navigation"
            data-text="english">English</a>
          </router-link>
          <router-link
            tag="li"
            to="/faq"
            class="nav-items"
            data-attribute="navbar"
            :class="{'isActive' : $route.name === 'faq'}"
          >
            <a class="nav-link" data-attribute="navbar" data-title="faq" data-event="link"
            data-action="click" 
            data-name="onclick" 
            data-type="internal link" 
            data-region="main navbar"
            data-section="sticky navigation"
            data-text="faq">FAQ</a>
          </router-link>
        </ul>
      </aside>
    </section>
  </div>
</template>

<script>
import axios from "axios";
import { mapGetters } from "vuex";
import { CHECK_AUTH, LOG_USER_OUT } from "../store/actions.type";
import { redirectUnauthorizedUser } from "../common/auth-redirect.util";
export default {
  name: "main-nav",
  data() {
    return {
      openNav: false
    };
  },
  methods: {
    openNavbar(){
      utag.link({
        event: 'collapse',
        action: 'open',
        name: 'onclick',
        type: 'click',
        region: 'navbar',
        section: 'sticky navigation',
        text: 'menu button mobile',
        tealium_event: 'collapse_open'
    })
    },
    closeNavbar(){
      utag.link({
        event: 'collapse',
        action: 'close',
        name: 'onclick',
        type: 'click',
        region: 'navbar',
        section: 'sticky navigation',
        text: 'menu button mobile',
        tealium_event: 'collapse_close'
    })
    },
    welcomeBtn(){
      this.openNav = !this.openNav;
      utag.link({
        event: 'collapse',
        action: (this.openNav === true) ? 'open' : 'close',
        name: 'onclick',
        type: 'click',
        region: 'navbar',
        section: 'authentication navbar',
        text: 'welcome user',
        tealium_event: (this.openNav === true) ? 'collapse_open' : 'collapse_close'
    })
    },
    HamburgerButton(){
      this.openNav = !this.openNav;
      utag.link({
        event: 'collapse',
        action: (this.openNav === true) ? 'open' : 'close',
        name: 'onclick',
        type: 'click',
        region: 'navbar',
        section: 'sticky navigation',
        text: 'menu button mobile',
        tealium_event: (this.openNav === true) ? 'collapse_open' : 'collapse_close'
    })
    },
    LoginUser() {
      this.$store.dispatch(CHECK_AUTH, "login").then(validUser => {
        if (validUser.status && validUser.status === 401) {
          redirectUnauthorizedUser(validUser);
        } else {
          this.$router.push({ name: "home" });
        }
      });
    },
    getAuthState() {
      if (this.currentUser.user) {
        return this.currentUser.user.status === "returning_user" || this.currentUser.user.status === "ineligible"? true : false;
      }
    },
    handleScroll(event) {
      if (window.innerWidth > 992) {
        // let heightOf2Navs =
        //   document.getElementById("top-nav").offsetHeight +
        //   document.getElementById("secondary-nav").offsetHeight;
        var header = document.getElementById("shadow-navigation");
        let main = document.getElementById("main-template");
        if (window.pageYOffset >= 132) {
          header.classList.add("sticky");
          main.classList.add("paddingAdj");
        } else {
          header.classList.remove("sticky");
          main.classList.remove("paddingAdj");
        }
      } else {
        var header = document.getElementById("mobile-nav");
        let main = document.getElementById("main-template");
        header.classList.add("sticky-white");
        main.classList.add("paddingAdj");
      }
    },
    logUserOut() {
      this.$store
        .dispatch(LOG_USER_OUT, this.currentUser.user.email_address).then(validUser => {
          this.$router.push({ name: "home" });
      });
    }
  },
  computed: {
    ...mapGetters(["currentUser", "isAuthenticated"])
  },
  created() {
    window.addEventListener("scroll", this.handleScroll);
    window.addEventListener("resize", this.handleScroll);
    window.addEventListener("click", this.onClick);
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
    window.addEventListener("resize", this.handleScroll);
    window.addEventListener("click", this.onClick);
  }
};
</script>
<style scoped>
.navbar-toggler {
  margin-left: auto;
}
.canvas-nav {
  text-align: right;
}
.asu-careercatalyst-logo{
  height:60px ;
}
@media (max-width: 768px) {
  .canvas-nav {
    text-align: center;
  }
  .text-small-center {
    margin: 0 auto;
  }
}
.asu-careercatalyst-logo{
  height:50px ;
}
.sticky {
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 999;
}
#secondary-nav .nav-link {
  color: black !important;
}

#secondary-nav .isActive .nav-link {
  color: #8c1d40 !important;
  font-weight: bold;
}
</style>
